import Glide from '@glidejs/glide';

export const PXTeamListing = (function () {
	'use strict';

	let sliders;

	function init() {
		sliders = document.querySelectorAll('.pxblock--team-listing .glide');

		if (sliders.length === 0) return;

		sliders.forEach((s) => {
			let sliderNavButtons = s.querySelectorAll('.glide__arrows > button');
			let g = new Glide(s, {
				type: 'slider',
			}).mount();

			// set aria hidden & tabindex
			g.on('move.after', (e) => {
				let slideItem = $(s).find('.glide__slide')

				$.each(slideItem, function (i, val) { 
					let item = $(val)

					item.removeAttr('aria-hidden')
					item.find('button, a, input, textarea').removeAttr('tabindex')

					if (!item.hasClass('glide__slide--active')) {
						item.attr('aria-hidden', 'true')
						item.find('button, a, input, textarea').attr('tabindex', '-1')
					}
				})
			})					

			sliderNavButtons.forEach((b) => {
				b.addEventListener('click', function (ev) {
					let dir = this.classList.contains('prev') ? '<' : '>';
					g.go(dir);
				});
			});
		});
	}

	return {
		init: init,
	};
})();
